module.exports = __webpack_public_path__ + "img/AdobeStock_415766683.542b241a.jpeg";